import { composeValidators } from '@alfa-bank/site-form-helpers/validation/utils';
import type { TValidatorValue } from '@alfa-bank/site-form-helpers/src/validation/models';
import { getNumbersFromStr } from '@alfa-bank/site-form-helpers/text/get-numbers-from-str';

export const PASSPORT_ERROR = 'Некорректные паспортные данные';

export const isValidPassport = (value: TValidatorValue) => {
    if (getNumbersFromStr(value)?.length !== 10) return PASSPORT_ERROR;

    return undefined;
};

export const validatePassport = () => composeValidators(isValidPassport);
